<template>
<v-container fluid>
     <v-dialog v-model="stn_dialog" max-width="800px">
        <v-card class="mx-auto" max-width="800" outlined>
          <v-card-title>
            <v-icon color="blue" large left>
              mdi-home
            </v-icon>
            Live Sation Update
          </v-card-title>
          <v-divider class="mx-4" :inset="true"></v-divider>
          <v-card-text>
            <v-form v-model="valid">
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    v-model = "stn_code"
                    :items="stations"
                    :filter="stationFilter"
                    color="white"
                    item-value="stn_code"
                    item-text="stn_name"
                    label="Station"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col>
                  <v-radio-group
                    v-model="North_south"
                    row
                  >
                    <v-radio
                      label="UP"
                      value="UP"
                    ></v-radio>
                    <v-radio
                      label="DN"
                      value="DN"
                    ></v-radio>
                    <v-radio
                      label="ALL"
                      value="ALL"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="blue darken-1" text @click="cancel">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="saveSation()">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <table id="display_header">
        <tr>
          <th><img src="./../assets/emu.png"></th>
          <th style="font-size:64px;font-weight: bold;color:#FF0000;text-align: right">Welcome to {{getStationName(stn_code)}}<th>
          <th><v-btn text icon color="purple" dark @click.native.stop="stn_dialog=true">
            <v-icon dark>mdi-pencil</v-icon>
          </v-btn>
          <th>
            <th>
            <v-btn text icon color="purple" dark @click.native.stop="speak()">
              <v-icon dark>mdi-bullhorn</v-icon>
            </v-btn>
          </th>
          <th style="font-size:72px;font-weight: bold;color:#FF0000;text-align: right">{{curTime}}</th>
        </tr>
      </table>
    <table id="customers">
      <tr>
        <th>UP/DN</th>
        <th>TRAIN NO</th>
        <th>LAST STATION</th>
        <th>LT/BT</th>
        <th>SCH. ARR</th>
        <th>PF</th>
      </tr>
      <tr v-for ="item in trains" >
        <td style="font-size:72px;font-weight: bold;">{{item.up_dn}}</td>
        <td style="font-size:72px;font-weight: bold;color: #FFD700">{{item.train_no}}</td>
        <td style="font-size:72px;font-weight: bold;width: 50%">{{item.last_stn_name}}</td>
        <td>
          <v-chip v-if="item.last_stn_code" large dark :color="getFormattedTimeSec(item.status, item.last_stn_code).colour_code">
            <span style="font-size:36px;font-weight: bold">{{getFormattedTimeSec(item.status, item.last_stn_code).tt}}</span>
          </v-chip>
        </td>
        <td style="font-size:72px;font-weight: bold;color: #FFD700">{{item.wtt_arr.substring(0,5)}}</td>
        <td style="font-size:72px;font-weight: bold;color: #FFD700">{{item.pf}}</td>
      </tr>
    </table>
</v-container>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import {
  mapState,
  mapGetter,
  mapActions
} from 'vuex'

export default {
  name: 'LiveStation',
  data() {
    return {
      search: '',
      valid: false,
      dateRules: [v => !!v || 'Date is required'],
      errors: [],
      train: {},
      train_loading: false,
      trains: [],
      stations:[],
      train_date: moment().format('DD/MM/YYYY HH:mm:ss'),
      isLoading: false,
      stn_code: 'DDJ',
      lastupdate: moment().format('HH:mm:ss'),
      lastupdate_relative: moment().fromNow(),
      fetchTimer: null,
      curTime: null,
      stn_dialog: false,
      North_south: 'ALL',
    }
  },
  computed: {
    ...mapState(['curDeviceId', 'curDeviceName', 'curTrainNo', 'curTrainDate', 'curOrg', 'curArr', 'curDest', 'curDep', 'actDep', 'actArr']),
  },

  created() {
    this.stn_code = localStorage.getItem('live_stn_code')
    this.North_south = localStorage.getItem('north_south')
    axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
    axios.get(`${process.env.VUE_APP_API_URL}/timetable/stations`)
      .then(response => {
        this.stations = response.data;
        this.initialize()
      })
      .catch(e => {
        console.log(e)
      })
      const events = new EventSource(`${process.env.VUE_APP_API_URL}/sse-server`);
      events.onmessage = (event) => {
        this.curTime = event.data
      };
  },

  mounted() {
    this.fetchTimer = setInterval(() => this.initialize(), 60000);
  },

  destroyed() {
    clearInterval(this.fetchTimer);
  },
  methods: {
    ...mapActions(['updateCurDeviceId', 'updateCurDeviceName', 'updateCurTrainNo', 'updateCurTrainDate', 'updateCurOrg', 'updateCurArr', 'updateCurDest', 'updateCurDep', 'updateActDep', 'updateActArr']),
    initialize() {
      //      this.updateCurTrainDate(moment(this.train_date).format("YYYY-MM-DD"))
      //      console.log(this.curDeviceId)
      this.isLoading = true
      var p = {
        // start_time: moment('2021-01-13 17:00:00').format('YYYY-MM-DD HH:mm:ss'),
        start_time: moment().format('YYYY-MM-DD HH:mm:ss'),
        stn_code: this.stn_code
      }
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.get(`${process.env.VUE_APP_API_URL}/timetable/tc/livestn1_for_website`, {
          params: p
        })
        .then(response => {
          var that = this
          var trns = []
          _.forEach(response.data, function(o) {
            o.destination = _.find(that.stations, {'stn_code': o.dest})['stn_name']
            if (o.last_stn_code) {
               o.last_stn_name = o.last_stn_code && _.find(that.stations, {'stn_code': o.last_stn_code})['stn_name']
            }
            if (o.train_no % 2 == 0) {
              o.up_dn = "DN"
            } else {
              o.up_dn = "UP"
            }
            if (o.last_stn_late_dep != null) {
              o.status = o.last_stn_late_dep
            } else if (o.last_stn_late_arr != null) {
              o.status = o.last_stn_late_arr
            } else {
              o.status = 0
            }
            if (o.last_stn_dep != null) {
              o.last_arr_dep_time = o.last_stn_dep
            } else if (o.last_stn_arr != null) {
              o.last_arr_dep_time = o.last_stn_arr
            } else {
              o.last_arr_dep_time = null
            }
            if (trns.length < 6) {
               trns.push(o)
            }
          });

          if (that.North_south == "DN") {
             that.trains =  _.filter(trns, function(o) { return (o.train_no % 2 == 0);})
          } else if (this.North_south == "UP") {
            that.trains =  _.filter(trns, function(o) { return (o.train_no % 2 > 0);})
          } else {
            that.trains = trns
          }
          this.isLoading = false
          that.train_date = moment().format('DD/MM/YYYY HH:mm:ss')
          // console.log(that.trains);
        })
        .catch(e => {
           console.log(e)
        })
    },

    stationFilter (item, queryText, itemText) {
      const textOne = item.stn_name.toLowerCase()
      const textTwo = item.stn_code.toLowerCase()
      const searchText = queryText.toLowerCase()
      return textOne.indexOf(searchText) > -1 ||
             textTwo.indexOf(searchText) > -1
    },
    saveSation() {
      console.log(this.stn_code,this.North_south)
      this.initialize()
      localStorage.setItem('live_stn_code', this.stn_code)
      localStorage.setItem('north_south', this.North_south)
      this.stn_dialog = false
    },
    cancel() {
      this.stn_dialog = false
    },
    speak() {
      window.speechSynthesis.getVoices().forEach(function(voice) {
        console.log(voice.name, voice.default ? voice.default :'');
      });
      var msg = new SpeechSynthesisUtterance();
      var voices = window.speechSynthesis.getVoices();
      msg.voice = voices[9]; // Note: some voices don't support altering params
      // msg.voiceURI = 'native';
      msg.volume = 1; // 0 to 1
      msg.rate = 1; // 0.1 to 10
      msg.pitch = 1; //0 to 2
      msg.text = this.trains[0].destination.toLowerCase() + ' local; coming on platform number, ' + this.trains[0].pf;
      msg.lang = 'en-UK';
      msg.onend = function(e) {
        console.log('Finished in ' + event.elapsedTime + ' seconds.');
      };

      speechSynthesis.speak(msg);
    },
    getFormattedDate(t) {
      var lt = moment(t).format("YYYY-MM-DD HH:mm:ss")
      var testDateUtc = moment.utc(lt);
      var localDate = moment(testDateUtc).local();
      return localDate.format("DD/MM/YYYY")
    },
    getFormattedTime(t) {
      return moment.utc(t).format("HH:mm")
    },
    getFormattedTimeSec(t, last_stn) {
      if (last_stn) {
        if ( t < -59) {
          return {tt:moment.utc(Math.abs(t) * 1000).format('HH:mm'), color_code: '#ADFF2F'}
        } else if (t > 59 ) {
          return {tt: moment.utc(Math.abs(t) * 1000).format('HH:mm'),colour_code: '#FF4500'}
        } else {
          return {tt:'RT', colour_code: '#ADFF2F'}
        }
      } else {
          return {tt:null, colour_code: null}
      }
    },
    getTimeInMin(t) {
      if (t) {
        return t.substring(0, 5)
      }
    },
    getStationName(stn) {
       var stn_obj =  _.find(this.stations, {'stn_code': stn})
       if (stn_obj) {
         return stn_obj['stn_name']
      }
    }
  }
}
</script>
<style scoped>
.itemclass {
    color: blue;
    font-size:36px;
    font-weight: bold;
    text-align: center;
}
.headerclass {
    color: black;
    font-size:36px;
    font-weight: bold;
    text-align: center;
}
/* #customers td, #customers th {
border: 1px solid #ddd;
padding: 8px;
border-color: #00BFFF;
} */
#customers {
   width: 100%;
   border-collapse: collapse;
}

#customers tr:nth-child(even){background-color: #696969;}

#customers tr {
  background-color: #000000;
  font-size:36px;
  text-align: center;
  color: white;
  border-bottom: 1px solid #ddd;
border-top: 1px solid #ddd;
border-collapse: collapse;
border-color: #00BFFF;
}

#customers th {
font-size:36px;
padding-top: 12px;
padding-bottom: 12px;
text-align: center;
background-color: #00BFFF;
color: black;
}

#display_header {
   width: 100%;
   border-collapse: collapse;
}


#display_header th {
font-size:36px;
padding-top: 12px;
padding-bottom: 12px;
text-align: center;
background-color: #FFFFFF;
color: black;
}

</style>
